<template>
    <v-sheet>
        <v-tabs v-model="levelThreeTab" color="primary" density="compact">
            <v-tab value="Detail">Detail</v-tab>
            <v-tab value="List">List</v-tab>
        </v-tabs>

        <v-divider></v-divider>

        <v-window v-model="levelThreeTab" class="py-3">
            <v-window-item value="Detail">
                <DetailWindow />
            </v-window-item>

            <v-window-item value="List">
                <ListWindow />
            </v-window-item>
        </v-window>
    </v-sheet>
</template>

<script setup>
import {} from "vue";
import DetailWindow from "./MaterialsWindow/DetailWindow.vue";
import ListWindow from "./MaterialsWindow/ListWindow.vue";
import {useJobEntryStore} from "../../../../../stores/ProjectManagement/JobEntry";
import {storeToRefs} from "pinia";

const jobEntryStore = useJobEntryStore()

const { levelThreeTab } = storeToRefs(jobEntryStore)
</script>

<style scoped>

</style>
